
import { defineComponent } from "vue";
import {
  ersteFremdsprache,
  ersteGesellschaftwissenschaft,
  ersteNaturwissenschaft,
  fillCourses,
  kuenstlerischesFach,
  lks,
  muendlich,
  pflichtfach,
  zweitesFach,
} from "@/scripts/MarkCalculator";
import { SubjectName, Marks } from "@/scripts/Types";
import { sum } from "@/scripts/helper";
import MarkInputComponent from "@/components/MarkInputComponent.vue";
import QualifikationGesamtComponent from "@/components/QualifikationGesamt.vue";
import Qualifikation2Component from "@/components/Qualifikation2.vue";
import { getAbiDurchschnitt } from "@/scripts/GradeTable";

export default defineComponent({
  name: "HelloWorld",
  props: {},
  components: {
    MarkInputComponent,
    QualifikationGesamtComponent,
    Qualifikation2Component,
  },
  data() {
    return {
      newSubject: "",
      abiDurchschnitt: "nicht bestanden",
      pointsQuali1: 0,
      pointsQuali2: 0,
      facharbeit: 0,

      subjects: [
        "Deutsch",
        "Englisch",
        "Latein",
        "Französisch",
        "Spanisch",
        "Mathe",
        "Chemie",
        "Physik",
        "Biologie",
        "Informatik",
        "Musik",
        "Kunst",
        "DS",
        "Sport",
        "Geschichte",
        "Sozialkunde",
        "Erdkunde",
        "Religion_Ethik",
      ] as SubjectName[],
      ownSubjects: [] as SubjectName[],
      marks: {
        Deutsch: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Englisch: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Latein: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Französisch: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Spanisch: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Mathe: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Chemie: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Physik: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Biologie: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Informatik: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Musik: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Kunst: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        DS: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Sport: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Geschichte: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Sozialkunde: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Erdkunde: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
        Religion_Ethik: {
          "11_2": 0,
          "12_1": 0,
          "12_2": 0,
          "13_1": 0,
        },
      } as Marks,
      mean: 0,
      usedCourses_1: 0,
      subjectsMuendlich: [] as SubjectName[],
      usedCourses: [
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
      ],
      singlePointsQuali2: [0, 0, 0, 0, 0],
    };
  },
  watch: {
    pointsQuali1() {
      this.abiDurchschnitt = getAbiDurchschnitt(
        this.pointsQuali1 + this.pointsQuali2
      );
    },
    pointsQuali2() {
      this.abiDurchschnitt = getAbiDurchschnitt(
        this.pointsQuali1 + this.pointsQuali2
      );
    },
    marks: {
      handler() {
        this.usedCourses = [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
        ];
        lks(this.usedCourses, this.ownSubjects, this.marks);
        this.usedCourses = pflichtfach(
          this.ownSubjects,
          this.usedCourses,
          "Deutsch"
        );
        this.usedCourses = pflichtfach(
          this.ownSubjects,
          this.usedCourses,
          "Mathe"
        );
        this.usedCourses = muendlich(
          this.ownSubjects,
          this.subjectsMuendlich,
          this.usedCourses
        );
        kuenstlerischesFach(this.ownSubjects, this.usedCourses, this.marks);
        ersteFremdsprache(
          this.ownSubjects,
          this.usedCourses,
          this.marks,
          this.subjectsMuendlich
        );
        ersteNaturwissenschaft(
          this.ownSubjects,
          this.usedCourses,
          this.marks,
          this.subjectsMuendlich
        );
        ersteGesellschaftwissenschaft(
          this.ownSubjects,
          this.usedCourses,
          this.marks,
          this.subjectsMuendlich
        );
        zweitesFach(this.ownSubjects, this.usedCourses, this.marks);
        fillCourses(this.ownSubjects, this.usedCourses, this.marks);
      },
      deep: true,
    },
  },
  methods: {
    getTotalUsedCourseNum() {
      let res = 0;
      for (let i = 0; i < this.usedCourses.length; i++) {
        res += this.getUsedCourseNum(i);
      }
      return res;
    },
    getTotalPointSum() {
      let res = 0;
      for (let i = 0; i < this.ownSubjects.length; i++) {
        const name = this.ownSubjects[i];

        if (this.marks[name] == undefined) {
          return 0;
        }
        const pointSum: number =
          this.usedCourses[i][0] * this.marks[name]!["11_2"] +
          this.usedCourses[i][1] * this.marks[name]!["12_1"] +
          this.usedCourses[i][2] * this.marks[name]!["12_2"] +
          this.usedCourses[i][3] * this.marks[name]!["13_1"];

        res += pointSum;
      }
      if (this.facharbeit > 4) {
        res += this.facharbeit;
      }
      this.pointsQuali1 = Math.round((res / 44) * 40);
      return res;
    },
    getUsedCourseNum(index: number) {
      return this.usedCourses[index].filter((x: number) => x > 0).length;
    },
    getSubjectPoints(index: number, name: SubjectName): string {
      if (this.marks[name] == undefined) {
        return "0";
      }
      const pointSum: number =
        this.usedCourses[index][0] * this.marks[name]!["11_2"] +
        this.usedCourses[index][1] * this.marks[name]!["12_1"] +
        this.usedCourses[index][2] * this.marks[name]!["12_2"] +
        this.usedCourses[index][3] * this.marks[name]!["13_1"];
      if (sum(this.usedCourses[index]) == 8) {
        return (pointSum / 2).toString() + " * 2 = " + pointSum.toString();
      }
      return pointSum.toString();
    },
    muendlichChange(e: any, subject: SubjectName) {
      if (e.target.checked) {
        if (this.subjectsMuendlich.length >= 2) {
          e.target.checked = false;
          return;
        }
        this.subjectsMuendlich.push(subject);
      } else {
        this.subjectsMuendlich = this.subjectsMuendlich.filter(
          (item) => item != subject
        );
      }
    },
  },
});
